import { render, staticRenderFns } from "./AvoidExpertUnitForm.vue?vue&type=template&id=699c791c&scoped=true"
import script from "./AvoidExpertUnitForm.vue?vue&type=script&lang=js"
export * from "./AvoidExpertUnitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699c791c",
  null
  
)

export default component.exports